<template>
  <div class="search-div">
    <input
      type="search"
      class="search search-full"
      placeholder="Digite aqui o que você procura..."
      v-model="fieldSearch"
      @keyup="detectEnter"
    />
    <router-link
      placeholder="Digite aqui o que você procura..."
      :to="`/busca?termo=${fieldSearch}`"
    >
      <font-awesome-icon class="search-icon" icon="search" />
    </router-link>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      fieldSearch: ""
    };
  },
  methods: {
    detectEnter(e) {
      let key = e.which || e.keyCode;
      var simulateClick = function(elem) {
        let evt = new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window
        });
        !elem.dispatchEvent(evt);
      };
      if (key == 13) {
        let nextASibling = e.currentTarget.nextSibling;
        simulateClick(nextASibling);
      }
    }
  }
};
</script>
<style lang="scss">

@media (max-width: 767px) {
  .search-div {
    width: 100% !important;
  }
}

.search-div {
  width: 85%;
  position: relative;
  margin-bottom: 20px;
  input {
    z-index: 1;
    &:focus,
    &:hover {
      + a {
        display: none;
      }
    }
    + a {
      width: 50px;
      text-align: center;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 23px;
      bottom: 0;
      z-index: 2;
    }
  }
}
</style>